//import "./profile.scss";
import { useContext } from "react";
import { AuthContext } from "../../context/authContext";
import { useState ,useEffect} from "react";
import { useForm } from "react-hook-form";
import Button from 'react-bootstrap/Button';
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import axios from "axios";
import {
  MDBCol,
  MDBContainer,
  MDBRow,
  MDBCard,
  MDBCardText,
  MDBCardBody,
  MDBCardImage,
  MDBBtn,
  MDBBreadcrumb,
  MDBBreadcrumbItem,
  MDBProgress,
  MDBProgressBar,
  MDBIcon,
  MDBListGroup,
  MDBListGroupItem,
  MDBInputGroup
} from 'mdb-react-ui-kit';
import {Buffer} from 'buffer';
const SERVER = `https://volunteer-server.onrender.com`
//const SERVER = `http://localhost:8800`

export default function Profile() {
const [toggled,setToggle] = useState(true)
const [profile, setProfile] = useState(null);
const [data,setData] = useState([])
const [mimeType,setMimeType] = useState("")
const { register, handleSubmit } = useForm();
const navigate = useNavigate();
const [image,setImage] = useState("")
const [text,setTexts] = useState({
  email:data.email,
  firstName:data.firstName,
  lastName:data.lastName,
  phone_number:data.phone_number,
  address:data.address
})
const { currentUser,setCurrentUser } = useContext(AuthContext);

  const parseData = async()=>{
    const result = await axios(`${SERVER}/api/users/find/${JSON.parse(localStorage.getItem("user")).ID_user}`);
    
    setData(result.data);
    const buffer = result.data.data 
    const image = new Buffer(buffer).toString('base64')
    const mimeType = result.data.type // e.g., image/png
    setImage(image)
    setMimeType(mimeType)
  }
  
  useEffect(() => {
    parseData()
  }, []);

    const onSubmit = async (data) => {
        const formData = new FormData();
        formData.append("file", data.file[0]);
        formData.append("email",text.email)
        formData.append("firstName",text.firstName)
        formData.append("lastName",text.lastName)
        formData.append("phone_number",text.phone_number)
        formData.append("address",text.address)
        formData.append("ID_user",JSON.parse(localStorage.getItem("user")).ID_user)
        const res = await fetch(`${SERVER}/api/update`, {
            method: "POST",
            body: formData,
        }).then((res) => res.json());
        alert(JSON.stringify(`${res.message}, status: ${res.status}`));
        setToggle(!toggled)
    };

  const handleChange = (e) => {
    setTexts((prev) => ({ ...prev, [e.target.name]: [e.target.value] }));
  };

//   const arrayBufferToBase64=(buffer) =>{
//     var binary = '';
//     var bytes = [].slice.call(new Uint8Array(buffer));
//     bytes.forEach((b) => binary += String.fromCharCode(b));
//     return window.btoa(binary);
// }
useEffect(() => {
  parseData()
}, [navigate]);

const toggle = ()=>{
  console.log(image)
  setToggle(!toggled)
}
const logout = () => {
  const emptyUser = {
    ID_user:0,
    email:null,
    phone_number:null,
    category:"u",
    firstName:null,
    lastName:null,
    img:null,
    address:null,
    data:null,
    type:null
  }
  localStorage.clear();
  localStorage.setItem("user",JSON.stringify(emptyUser))
  setCurrentUser(emptyUser)
  navigate('/')
}

  return (
    <div>
      <MDBContainer className="py-5">

        <MDBRow>
          <MDBCol lg="4">
            <MDBCard className="mb-4">
              <MDBCardBody className="text-center">
                {/* <MDBCardImage
                  src="https://mdbcdn.b-cdn.net/img/Photos/new-templates/bootstrap-chat/ava3.webp"
                  alt="avatar"
                  className="rounded-circle"
                  style={{ width: '150px' }}
                  fluid /> */}
                <img src={`data:${mimeType};base64,${image}`} alt="" style={{ width: '50%',height:'50%' }}  />

                <p className="text-muted mb-4">Bay Area, San Francisco, CA</p>
                <div className="d-flex justify-content-center mb-4">
                  {toggled ?  <Button variant="primary" onClick={toggle}>{toggled ? "Edit" : "Save"}</Button> : ""}
                {/* <Button variant="primary" onClick={toggle}>{toggled ? "Edit" : "Save"}</Button> */}
                <Button variant="primary" onClick={logout} style={{ marginLeft:'2%' }}>Log out</Button>
                </div>
              </MDBCardBody>
            </MDBCard>

        
          </MDBCol>
          <MDBCol lg="8">
    {toggled ? 
    
            <MDBCard className="mb-4">
              <MDBCardBody>
                <MDBRow>
                  <MDBCol sm="3">
                    <MDBCardText>First Name</MDBCardText>
                  </MDBCol>
                  <MDBCol sm="9">
                    <MDBCardText className="text-muted">{data.firstName}</MDBCardText>
                  </MDBCol>
                </MDBRow>
                <hr />
                <MDBRow>
                  <MDBCol sm="3">
                    <MDBCardText>Last Name</MDBCardText>
                  </MDBCol>
                  <MDBCol sm="9">
                    <MDBCardText className="text-muted">{data.lastName}</MDBCardText>
                  </MDBCol>
                </MDBRow>
                <hr />
                <MDBRow>
                  <MDBCol sm="3">
                    <MDBCardText>Email</MDBCardText>
                  </MDBCol>
                  <MDBCol sm="9">
                    <MDBCardText className="text-muted">{data.email}</MDBCardText>
                  </MDBCol>
                </MDBRow>
                <hr />
                <MDBRow>
                  <MDBCol sm="3">
                    <MDBCardText>Mobile</MDBCardText>
                  </MDBCol>
                  <MDBCol sm="9">
                    <MDBCardText className="text-muted">{data.phone_number}</MDBCardText>
                  </MDBCol>
                </MDBRow>
                <hr />
                <MDBRow>
                  <MDBCol sm="3">
                    <MDBCardText>Address</MDBCardText>
                  </MDBCol>
                  <MDBCol sm="9">
                    <MDBCardText className="text-muted">{data.address}</MDBCardText>
                  </MDBCol>
                </MDBRow>
              </MDBCardBody>
            </MDBCard>
            :






            <form style={{ marginTop:'2%'}} onSubmit={handleSubmit(onSubmit)}>
            <MDBCard className="mb-4">
            <MDBCardBody>
              <MDBRow>
                <MDBCol sm="3">
                  <MDBCardText>First Name</MDBCardText>
                </MDBCol>
                <MDBCol sm="9">
                <MDBInputGroup >
                <input className='form-control'  type='text' placeholder="Recipient's username" {...register("firstName")} name="firstName"  onChange={handleChange} value={text.firstName} />
              </MDBInputGroup>
                </MDBCol>
              </MDBRow>
              <hr />
              <MDBRow>
                <MDBCol sm="3">
                  <MDBCardText>Last Name</MDBCardText>
                </MDBCol>
                <MDBCol sm="9">
                <MDBInputGroup >
                <input className='form-control' type='text' placeholder="Recipient's username" {...register("lastName")} name="lastName"  onChange={handleChange} value={text.lastName} />
              </MDBInputGroup>
                </MDBCol>
              </MDBRow>
              <hr />
              <MDBRow>
                <MDBCol sm="3">
                  <MDBCardText>Email</MDBCardText>
                </MDBCol>
                <MDBCol sm="9">
                <MDBInputGroup >
                <input className='form-control' type='text' required placeholder="Recipient's username" {...register("email")} name="email"  onChange={handleChange} value={text.email} />
              </MDBInputGroup>
                </MDBCol>
              </MDBRow>
              <hr />
              <MDBRow>
                <MDBCol sm="3">
                  <MDBCardText>Mobile</MDBCardText>
                </MDBCol>
                <MDBCol sm="9">
                <MDBInputGroup >
                <input className='form-control' type='text' placeholder="Recipient's username" {...register("phone_number")} name="phone_number"  onChange={handleChange} value={text.phone_number} />
              </MDBInputGroup>
                </MDBCol>
              </MDBRow>
              <hr />
              <MDBRow>
                <MDBCol sm="3">
                  <MDBCardText>Address</MDBCardText>
                </MDBCol>
                <MDBCol sm="9">
                <MDBInputGroup >
                <input className='form-control' type='text' placeholder="Recipient's username"  {...register("address")} name="address"  onChange={handleChange} value={text.address}  />
              </MDBInputGroup>
                </MDBCol>
              </MDBRow>
              <label class="form-label" for="customFile">Default file input example</label>
              <input type="file" class="form-control" id="customFile" name="file" {...register("file")}   onChange={(e) => setProfile(e.target.file[0])}/>    
            </MDBCardBody>
          </MDBCard>
          <Button variant="primary" type="submit" style={{ marginLeft:'2%' }}>SAVE</Button>
        
          </form>
         }
           
          </MDBCol>
        </MDBRow>
      
      { currentUser.category=="v" ? <>
      <Link to={'/organizations'}> <Button variant="primary" type="submit" style={{ marginLeft:'2%' }}>CREATE ORGANIZATION</Button> </Link>
      <Link to={'/control'}> <Button variant="primary" type="submit" style={{ marginLeft:'2%' }}>ADD VOLUNTEER</Button> </Link>
      </>: null}
      </MDBContainer>
    </div>
  );
}